import { ApiProperty } from "@nestjs/swagger";

export class SupplierLoginDto{
    @ApiProperty()
    userName : string;
    @ApiProperty()
    password : string;
} 

export class SupplierIdReq{
    @ApiProperty()
    id: number;
    versionFlag?: number;
    isActive ?: boolean;
    constructor(id: number, versionFlag?: number, isActive ?: boolean) {
        this.id = id;
        this.versionFlag = versionFlag;
        this.isActive = isActive;
    }
}